<!--start MPG - Landscape-->
<div class="row_container ptitle">
  <div class="col-12">
    <h2><strong>{{mpgResultTitle}}</strong></h2>
  </div>
</div>

<div class="row my-3">
  <!-- MPG card -->
  <div class="col mat-header-cell">
    <mat-card class="mat_gpr_card_print mat-elevation-z2">
      <div>
        <h2>MPG</h2>
        <div class="secondary-header-text">
          <span [innerHTML]="'RESULT.PER_M2_GFA_PER_YEAR' | translate| fixDimensions "></span>
        </div>
      </div>

      <div class="badge current_after_mpg">
        <div *ngIf="selectedDataSet == dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2">{{calculationResults?.mpg | number:'.3-3' | dynamicDecimal: true}}</div>
        <div *ngIf="selectedDataSet != dataSetSetting.A1A2" [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2">{{calculationResults?.mpg | number:'.3-3' | dynamicDecimal: false}}</div>
        <div *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)">{{calculationResultsAfter?.mpg | number:'.3-3' | dynamicDecimal: true}}</div>
      </div>
    </mat-card>

    <!-- Existing Building -->
    <div *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)">
      <div class="current_after_header">
        <div class="current_header">
          {{(isExistingBuildingCal ? 'COMPONENTS.PRODUCT.CURRENT' : 'RESULT.A1') | translate | titlecase}}
        </div>
        <div class="after_header">
          {{(isExistingBuildingCal ? 'COMPONENTS.PRODUCT.AFTER_INTERVENTION' : 'RESULT.A2') | translate }}
        </div>
      </div>

      <div class="mat_gpr_card_body_print" *ngFor="let element of calculationResults?.mpgPerPhase; let i = index">
        <div class="mr-auto">{{element.name}}</div>
        <div class="current_value">{{element.mpg | number:'.3-3' | dynamicDecimal: true}}</div>
        <div class="after_value">{{(calculationResultsAfter.mpgPerPhase[i].mpg) | number:'.3-3' | dynamicDecimal: true}}</div>
      </div>
    </div>

    <!-- New Building -->
    <div *ngIf="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2">
      <div class="mat_gpr_card_body_print" *ngFor="let element of calculationResults?.mpgPerPhase">
        <div class="mr-auto">{{element.name}}</div>
        <div class="after_value">{{element.mpg | number:'.3-3' | dynamicDecimal: true}}</div>
      </div>
    </div>
  </div>

  <!-- MKI card -->
  <div class="col mat-header-cell">
    <mat-card class="mat_gpr_card_print mat-elevation-z2">
      <div>
        <h2>MKI</h2>
        <div class="secondary-header-text">
          {{'RESULT.TOTAL_GFA_SERVICE' | translate}}
        </div>
      </div>

      <div class="badge current_after_mpg">
        <div [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2">{{calculationResults?.mki | number:'1.0-0' | dynamicDecimal: true}}</div>
        <div *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)">{{calculationResultsAfter?.mki | number:'1.0-0' | dynamicDecimal: true}}</div>
      </div>
    </mat-card>

    <!-- Existing Building -->
    <div *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)">
      <div class="current_after_header">
        <div class="current_header">
          {{(isExistingBuildingCal ? 'COMPONENTS.PRODUCT.CURRENT' : 'RESULT.A1') | translate | titlecase}}
        </div>
        <div class="after_header">
          {{(isExistingBuildingCal ? 'COMPONENTS.PRODUCT.AFTER_INTERVENTION' : 'RESULT.A2') | translate }}
        </div>
      </div>

      <div class="mat_gpr_card_body_print mat-elevation-z2"
           *ngFor="let element of calculationResults?.mkiPerPhase; let i=index">
        <div class="mr-auto">{{element.name}}</div>
        <div class="current_value">{{element.mki | number:'.3-3' | dynamicDecimal: true}}</div>
        <div class="after_value">{{(calculationResultsAfter.mkiPerPhase[i].mki) | number:'.3-3' | dynamicDecimal: true}}</div>
      </div>
    </div>

    <!-- New Building -->
    <div *ngIf="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2">
      <div class="mat_gpr_card_body_print mat-elevation-z2" *ngFor="let element of calculationResults?.mkiPerPhase">
        <div class="mr-auto">{{element.name}}</div>
        <div class="after_value">{{element.mki | number:'.3-3' | dynamicDecimal: false}}</div>
      </div>
    </div>
  </div>
</div>

<div class="row my-3" *ngIf="calculationResults">
  <!-- Paris proof -->
  <div class="col-6 mat-header-cell pt-3">
    <h5>{{'RESULT.PARIS_PROOF_HEADER' | translate}}</h5>
    <div class="mia-gwp-card">
        <div>
            <div class="text-secondary secondary-header-text">
                <span [innerHTML]="'RESULT.CALCULATED_EMBODIED_KG_CO2_PER_M2_BVO' | translate| fixDimensions "></span>
            </div>
        </div>

        <div class="badge current_after_mpg">
            <div [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="currentPPI">
                {{(calculationResults.parisProofIndicator || 0) | number:'1.0-0' | dynamicDecimal: true}}
            </div>
            <div *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)" data-test="newPPI">
                {{(calculationResultsAfter.parisProofIndicator || 0) | number:'1.0-0' | dynamicDecimal: true}}
            </div>
        </div>
    </div>
    
    <div class="mt-4">
      <h5>{{'RESULT.CONSTRUCTION_STORED_CARBON' | translate}}</h5>
        <div class="mia-gwp-card">
            <div>
                <div class="text-secondary secondary-header-text">
                    <span [innerHTML]="'RESULT.MATERIAL_RELATED_CO2_STORAGE' | translate| fixDimensions "></span>
                </div>
            </div>

            <div class="badge current_after_mpg">
              <div [class.current_mpg]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2" data-test="currentCSC">
                {{(calculationResults.constructionStoredCarbon || 0) | number:'.3-3' | dynamicDecimal: true}}
              </div>
              <div *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)" data-test="newCSC">
                {{(calculationResultsAfter.constructionStoredCarbon || 0) | number:'.3-3' | dynamicDecimal: true}}
              </div>
            </div>
        </div>
    </div>
  </div>

  <!-- GWP 50  only visible for new building -->
  <div class="col mat-header-cell" *ngIf="!isExistingBuildingCal">
    <mat-card class="mat_gpr_card_print mat-elevation-z2">
      <div>
        <h2>{{'RESULT.GWP_50_HEADER' | translate}}</h2>
        <div class="secondary-header-text">
          <span [innerHTML]="'RESULT.CALCULATED_EMBODIED_KG_CO2_PER_M2_GBO_PER_JAAR' | translate| fixDimensions "></span>
        </div>
      </div>

      <div class="badge current_after_mpg">
        <div *ngIf="selectedDataSet != dataSetSetting.A1A2" [class.current_mpg]="selectedDataSet != dataSetSetting.A1A2">{{calculationResults.gwp50 | number:'.3-3' | dynamicDecimal: false}}</div>
        <div *ngIf="selectedDataSet == dataSetSetting.A1A2" [class.current_mpg]="selectedDataSet != dataSetSetting.A1A2">{{calculationResults.gwp50 | number:'.3-3' | dynamicDecimal: true}}</div>
        <div *ngIf="selectedDataSet == dataSetSetting.A1A2">
          {{(calculationResultsAfter.gwp50 || 0) | number:'1.0-0' | dynamicDecimal: true}}
        </div>
      </div>
    </mat-card>

    <!-- Phase values -->
    <div>
      <div class="current_after_header" *ngIf="selectedDataSet == dataSetSetting.A1A2">
        <div class="current_header"> {{ 'RESULT.A1' | translate }} </div>
        <div class="after_header"> {{'RESULT.A2'| translate }} </div>
      </div>
      <div class="mat_gpr_card_body_print mat-elevation-z2"
           *ngFor="let gwp50Phase of calculationResults?.gwp50PerPhase; let i = index">
        <div class="mr-auto">{{gwp50Phase.name}}</div>
        <div class="current_value">{{gwp50Phase.gwp50 | number:'.3-3' | dynamicDecimal: true}}</div>
        <div class="after_value" *ngIf="selectedDataSet == dataSetSetting.A1A2">
          {{(calculationResultsAfter.gwp50PerPhase[i].gwp50) | number:'.3-3' | dynamicDecimal: true}}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- GWP row card-->
<div class="row my-2 py-4" *ngIf="calculationResults && selectedDataSet == dataSetSetting.A1">
  <div class="col-6 mat-header-cell">
    <h5>{{'RESULT.RESULT_IN_GPR_BUILDING' | translate}} 4.3</h5>
    <div class="mia-gwp-card">
      <div>
        <div class="header-text">{{'RESULT.GWP_100_JAAR' | translate}}</div>
        <div class="text-secondary secondary-header-text">
          <span [innerHTML]="'RESULT.CALCULATED_KG_CO2_M2_BVO_PER_JAAR' | translate| fixDimensions "></span>
        </div>
      </div>
      <div class="badge current_after_mpg">
        <div [class.current_mpg]="!isExistingBuildingCal" data-test="currentPPI">
          {{(calculationResults.globalWarmingPotential || 0) | number:'.3-3' | dynamicDecimal: false}}
        </div>
        <div *ngIf="isExistingBuildingCal" data-test="newPPI">
          {{(calculationResultsAfter.globalWarmingPotential || 0) | number:'.3-3' | dynamicDecimal: false}}
        </div>
      </div>
    </div>
  </div>

  <div class="col-6 mat-header-cell">
    <h5>{{'RESULT.RESULT_IN_GPR_BUILDING' | translate}} 4.4</h5>
    <div class="mia-gwp-card">
      <div>
        <div class="header-text">{{'RESULT.GWP_100_JAAR' | translate}}</div>
        <div class="text-secondary secondary-header-text">
          <span [innerHTML]="'RESULT.CALCULATED_KG_CO2' | translate| fixDimensions "></span>
        </div>
      </div>

      <div class="badge current_after_mpg">
        <div [class.current_mpg]="!isExistingBuildingCal" data-test="currentPPI">
          {{(calculationResults.globalWarmingPotential4point4 || 0) | number:'.3-3' | dynamicDecimal:false}}
        </div>
        <div *ngIf="isExistingBuildingCal" data-test="newPPI">
          {{(calculationResultsAfter.globalWarmingPotential4point4 || 0) | number:'.3-3' | dynamicDecimal:false}}
        </div>
      </div>
    </div>
  </div>
</div>
<!--end MPG-->
<!--start MPG per main element-->
<!-- Current -->
<div class="row_container pt-4 elem-header" [class.page_break]="!isExistingBuildingCal && selectedDataSet != dataSetSetting.A1A2"
     [class.element_container]="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)">
  <div class="col-12">
    <h2 class="pb-3"><strong>{{mpgResultTitlePerMainElementTitle}}</strong></h2>

    <div class="total_mpg">
      <h5>
        {{
          isExistingBuildingCal ? ('COMPONENTS.PRODUCT.CURRENT' | translate | titlecase) :
          selectedDataSet == dataSetSetting.A1A2 ? ('RESULT.A1' | translate | titlecase) : 'MPG'
        }}
      </h5>
      <div class="badge ml-auto">{{printData.totalMpg | number:'.3-3' | dynamicDecimal:false}}</div>
    </div>

    <hr class="hr_border_top">
  </div>
</div>

<!-- Main element with mpg current table and graph -->
<div class="row_container mpg">
  <div class="col-4 pl-0 pr-4">
    <table [dataSource]="currentMainElements" mat-table>
      <ng-container matColumnDef="colorCode">
        <td *matCellDef="let element" mat-cell>
          <span class="dot" style="background-color: {{element.colorCode}}"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <td *matCellDef="let element" mat-cell> {{element.name}} </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <td *matCellDef="let element" class="addedElementMpgTableColumn1" mat-cell>
          {{element.value | number:'.3-3' | dynamicDecimal:true}}
        </td>
      </ng-container>

      <ng-container matColumnDef="percentage">
        <td *matCellDef="let element" mat-cell> {{element.percentage}} %</td>
      </ng-container>

      <tbody>
        <tr *matRowDef="let row; let odd = odd; columns: mpgColumns;" [class.d-none]="odd" mat-row style="height:30px"></tr>
      </tbody>
    </table>
  </div>

  <div class="col-4 pl-4 pr-0">
    <table [dataSource]="currentMainElements" mat-table>
      <ng-container matColumnDef="colorCode">
        <td *matCellDef="let element" mat-cell>
          <span class="dot" style="background-color: {{element.colorCode}}"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <td *matCellDef="let element" mat-cell> {{element.name}} </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <td *matCellDef="let element" class="addedElementMpgTableColumn2" mat-cell>
          {{element.value | number:'.3-3' | dynamicDecimal:true}}
        </td>
      </ng-container>

      <ng-container matColumnDef="percentage">
        <td *matCellDef="let element" mat-cell> {{element.percentage}} %</td>
      </ng-container>

      <tbody>
        <tr *matRowDef="let row; columns: mpgColumns; let even = even" [class.d-none]="even" mat-row style="height:30px"></tr>
      </tbody>
    </table>
  </div>

  <div class="col-4 d-flex justify-content-center">
    <ngx-charts-pie-chart [scheme]="chartOption.colorScheme" [results]="currentMainElements"
                          [gradient]="chartOption.gradient" [legend]="chartOption.showLegend"
                          [legendPosition]="chartOption.legendPosition" [labels]="chartOption.showLabels"
                          [doughnut]="chartOption.isDoughnut" [arcWidth]="chartOption.arcWidth"
                          [tooltipDisabled]="chartOption.tooltipDisabled" [view]="chartOption.view"
                          [legendTitle]="chartOption.legendTitle">
    </ngx-charts-pie-chart>
  </div>
</div>

<!-- After -->
<ng-container *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)">
  <div class="row_container pt-4 elem-header">
    <div class="col-12">
      <div class="total_mpg">
        <h5>{{ (isExistingBuildingCal ? 'COMPONENTS.PRODUCT.AFTER_INTERVENTION' : 'RESULT.A2') | translate | titlecase}}</h5>
        <div class="badge ml-auto">{{printData.totalMpgAfter | number:'.3-3' | dynamicDecimal:false}}</div>
      </div>

      <hr class="hr_border_top">
    </div>
  </div>

  <!-- Main element with mpg after table -->
  <div class="row_container mpg">
    <div class="col-4 pl-0 pr-4">
      <table [dataSource]="afterMainElements" mat-table>
        <ng-container matColumnDef="colorCode">
          <td *matCellDef="let element" mat-cell>
            <span class="dot" style="background-color: {{element.colorCode}}"></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <td *matCellDef="let element" mat-cell> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <td *matCellDef="let element" class="addedElementMpgTableColumn1" mat-cell>
            {{element.value | number:'.3-3' | dynamicDecimal:true}}
          </td>
        </ng-container>

        <ng-container matColumnDef="percentage">
          <td *matCellDef="let element" mat-cell> {{element.percentage}} %</td>
        </ng-container>

        <tbody>
          <tr *matRowDef="let row; columns: mpgColumns; let odd = odd;" [class.d-none]="odd" mat-row style="height:30px"></tr>
        </tbody>
      </table>
    </div>

    <div class="col-4 pl-4 pr-0">
      <table [dataSource]="afterMainElements" mat-table>
        <ng-container matColumnDef="colorCode">
          <td *matCellDef="let element" mat-cell>
            <span class="dot" style="background-color: {{element.colorCode}}"></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <td *matCellDef="let element" mat-cell> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <td *matCellDef="let element" class="addedElementMpgTableColumn2" mat-cell>
            {{element.value | number:'.3-3' | dynamicDecimal:true}}
          </td>
        </ng-container>

        <ng-container matColumnDef="percentage">
          <td *matCellDef="let element" mat-cell> {{element.percentage}} %</td>
        </ng-container>

        <tbody>
          <tr *matRowDef="let row; columns: mpgColumns; let even = even" [class.d-none]="even" mat-row style="height:30px"></tr>
        </tbody>
      </table>
    </div>

    <div class="col-4 d-flex justify-content-center">
      <ngx-charts-pie-chart [scheme]="chartOption.colorScheme" [results]="afterMainElements"
                            [gradient]="chartOption.gradient" [legend]="chartOption.showLegend"
                            [legendPosition]="chartOption.legendPosition" [labels]="chartOption.showLabels"
                            [doughnut]="chartOption.isDoughnut" [arcWidth]="chartOption.arcWidth"
                            [tooltipDisabled]="chartOption.tooltipDisabled" [view]="chartOption.view"
                            [legendTitle]="chartOption.legendTitle">
      </ngx-charts-pie-chart>
    </div>
  </div>
</ng-container>
<!--end MPG per main element-->
<!--End new page (page2)-->
<!-- Environmental Impact (Page 3-4)-->
<div class="row_container ptitle">
  <div class="col-12">
    <h2 class="pb-0"><strong>{{envirnmentalCategoryTitle}}</strong></h2>
  </div>
</div>

<!-- Current environmentEffects -->
<div class="row ">
  <div class="col mat-header-cell">
    <table [dataSource]="environmentEffects" mat-table class="environmentCategory">
      <ng-container *ngFor="let column of tableColumns; index as index last as last; first as first">

        <ng-container matColumnDef="{{column}}" *ngIf="first">
          <th *matHeaderCellDef class="pl-0 first-column-size" mat-header-cell>
            <div class="current_header env_name_header">
              {{ isExistingBuildingCal ? ('COMPONENTS.PRODUCT.CURRENT' | translate | titlecase) : selectedDataSet == dataSetSetting.A1A2 ? ('RESULT.A1' | translate | titlecase) : '' }}
            </div>
          </th>
          <td *matCellDef="let element" class="pl-2 text-secondary" mat-cell> {{element[column]}} </td>
        </ng-container>

        <ng-container matColumnDef="{{column}}" *ngIf="!first">
          <th *matHeaderCellDef mat-header-cell [ngClass]="last ? 'text-center' : 'text-center column-size'">
            <small data-test="indicatorsLast">{{codes[column] | uppercase}}</small>
          </th>

          <ng-container *ngIf="(tableColumns.length - 2) === index; else columnTempRef">
            <td *matCellDef="let element" [ngClass]="last ? 'text-center' : 'text-center'" mat-cell>
              <span data-test="indicatorsTotal" class="total">
                {{element[column] | exponent}}
              </span>
            </td>
          </ng-container>

          <ng-template #columnTempRef>
            <ng-container *ngIf="last">
              <td data-test="indicatorsLast" *matCellDef="let element" class="text-secondary"
                  [ngClass]="last ? 'text-center' : 'text-center'" mat-cell>
                {{element[column]}}
              </td>
            </ng-container>

            <ng-container *ngIf="!last">
              <td *matCellDef="let element" [ngClass]="last ? 'text-center' : 'text-center'" mat-cell>
                <span data-test="resultValue" class="mki_phases">{{element[column] | exponent}}</span>
              </td>
            </ng-container>
          </ng-template>
        </ng-container>

      </ng-container>
      <tbody>
        <tr *matHeaderRowDef="tableColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: tableColumns;" mat-row></tr>
      </tbody>
    </table>
  </div>
</div>

<!-- After environmentEffects -->
<div class="row  ptitle" *ngIf="isExistingBuildingCal || (!isExistingBuildingCal && selectedDataSet == dataSetSetting.A1A2)">
  <div class="col mat-header-cell">
    <table [dataSource]="environmentEffectsAfter" mat-table class="environmentCategory">
      <ng-container *ngFor="let column of tableColumns; index as index last as last; first as first">

        <ng-container matColumnDef="{{column}}" *ngIf="first">
          <th *matHeaderCellDef class="pl-0 first-column-size" mat-header-cell>
            <div class="current_header env_name_header">
              {{ (isExistingBuildingCal ? 'COMPONENTS.PRODUCT.AFTER_INTERVENTION' : 'RESULT.A2') | translate | titlecase}}
            </div>
          </th>
          <td *matCellDef="let element" class="pl-2 text-secondary" mat-cell> {{element[column]}} </td>
        </ng-container>

        <ng-container matColumnDef="{{column}}" *ngIf="!first">
          <th *matHeaderCellDef mat-header-cell [ngClass]="last ? 'text-center' : 'text-center column-size'">
            <small data-test="indicatorsLast">{{codes[column] | uppercase}}</small>
          </th>

          <ng-container *ngIf="(tableColumns.length - 2) === index; else columnTempRef">
            <td *matCellDef="let element" [ngClass]="last ? 'text-center' : 'text-center'" mat-cell>
              <span data-test="indicatorsTotal" class="total">
                {{element[column] | exponent}}
              </span>
            </td>
          </ng-container>

          <ng-template #columnTempRef>
            <ng-container *ngIf="last">
              <td data-test="indicatorsLast" *matCellDef="let element" class="text-secondary"
                  [ngClass]="last ? 'text-center' : 'text-center'" mat-cell>
                {{element[column]}}
              </td>
            </ng-container>

            <ng-container *ngIf="!last">
              <td *matCellDef="let element" [ngClass]="last ? '' : 'text-center'" mat-cell>
                <span data-test="resultValue" class="mki_phases">{{element[column] | exponent}}</span>
              </td>
            </ng-container>
          </ng-template>
        </ng-container>
      </ng-container>

      <tbody>
        <tr *matHeaderRowDef="tableColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: tableColumns;" mat-row></tr>
      </tbody>
    </table>
  </div>
</div>
<!-- End of Environmental Impact (Page 3-4)-->
